<template lang="pug">
div.font14
  div
    informacoes-pessoa.pad(:pessoa="beneficiario.pessoa")
    informacoes-qualificacao(v-if="beneficiario.qualificacao" :cadastroOriginal="cadastroOriginal" :qualificacao="beneficiario.qualificacao", :isBeneficiario="true")
  div.pad-side
    div(v-if="isCasado")
      app-divider(label="Dados do cônjuge")
      informacoes-pessoa.pad(:pessoa="beneficiario.conjuge.pessoa" :isConjuge="true")
    div(v-if="isViuvo")
      app-divider(label="Dados do cônjuge")
      div.pad-side
        p
          span.label Possui certidão de óbito?
          span &nbsp {{hasCertidao}}
        p
          span.label CPF:
          span &nbsp {{filterNull(beneficiario.conjuge.pessoa.pessoaFisica.cpf)}}
        p
          span.label Nome:
          span &nbsp {{filterNull(beneficiario.conjuge.pessoa.pessoaFisica.nome)}}
</template>
<script>
import InformacoesPessoa from '@/components/informacoesCadastro/InformacoesPessoa.vue'
import AppDivider from './AppDivider'
import informacoesQualificacao from './informacoesCadastro/informacoesQualificacao'

export default {
  props: {
    beneficiario: {
      type: Object,
      required: true
    },
    cadastroOriginal: {
      type: Object,
      required: true
    },
    isBeneficiariosDiferentes: {
      type: Boolean,
      default: false
    }
  },
  components: {
    InformacoesPessoa,
    AppDivider,
    informacoesQualificacao
  },
  computed: {
    hasCertidao () {
      if (this.beneficiario.conjuge.pessoa.pessoaFisica.temCertidaoObito !== null) {
        return this.beneficiario.conjuge.pessoa.pessoaFisica.temCertidaoObito ? 'Sim' : 'Não'
      }
      return '-'
    },
    isCasado () {
      return this.beneficiario.pessoa.pessoaFisica &&
        ['UNIAO_ESTAVEL', 'CASADO', 'UNIAO_HOMOAFETIVA']
          .includes(this.beneficiario.pessoa.pessoaFisica.estadoCivil)
    },
    isViuvo () {
      return this.beneficiario.pessoa.pessoaFisica &&
        this.beneficiario.pessoa.pessoaFisica.estadoCivil === 'VIUVO'
    }
  },

  methods: {
    filterNull (atributo) {
      return atributo !== null ? atributo : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.pad {
  padding: 15px 5px;
}
.pad-side {
  padding: 0px 5px;
}
.font14 {
  font-size: 14px;
}
.label {
  font-weight: bold;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppVisualizarBeneficiario.vue